import React, {useEffect, useState} from 'react';
import {Col, Modal, Row} from "react-bootstrap";
import {word} from "../../word.js";
import {Autocomplete, TextField} from "@mui/material";
import moment from "moment";
import {useDispatch, useSelector} from "react-redux";
import BlueButton from "../BlueButton/BlueButton.js";
import qs from "query-string";
import ErrorToast from "../BlueButton/ErrorToast.js";
import Select from "react-select";
import {REACT_APP_API_URL} from "../../config.js";

function DayOffReport({onHide, show,allOptions}) {

    const [form, setForm] = useState({
        start_date: '',
        end_date: '',
        created_start: '',
        created_end: '',
        creator_ids: []
    })

    const handleChange = (name, val) => {
        const newStartDate = moment(val);
        setForm((prevState) => {
            if (name === 'start_date') {
                // assuming `value` is the new start_date
                const currentEndDate = moment(form.end_date);
                if (newStartDate.isAfter(currentEndDate)) {
                    return {
                        ...prevState,
                        start_date: newStartDate.format("YYYY-MM-DD"),
                        end_date: moment(newStartDate).add(1, 'day').format("YYYY-MM-DD")
                    }
                } else {
                    return {
                        ...prevState,
                        start_date: newStartDate.format("YYYY-MM-DD"),
                    }
                }
            }
            if (name === 'end_date') {
                const newEndDate = moment(val);
                const currentStartDate = moment(prevState.start_date);

                if (newEndDate.isBefore(currentStartDate)) {
                    return {
                        ...prevState,
                        end_date: newEndDate.format("YYYY-MM-DD"),
                        start_date: moment(newEndDate).subtract(1, 'day').format("YYYY-MM-DD")
                    };
                } else {
                    return {
                        ...prevState,
                        end_date: newEndDate.format("YYYY-MM-DD"),
                    };
                }
            }
            if (name === 'created_start') {
                const currentCreatedEnd = moment(prevState.created_end);
                if (newStartDate.isAfter(currentCreatedEnd)) {
                    return {
                        ...prevState,
                        created_start: newStartDate.format("YYYY-MM-DD"),
                        created_end: newStartDate.clone().add(1, 'day').format("YYYY-MM-DD"),
                    };
                } else {
                    return {
                        ...prevState,
                        created_start: newStartDate.format("YYYY-MM-DD"),
                    };
                }
            }

            if (name === 'created_end') {
                const currentCreatedStart = moment(prevState.created_start);
                if (newStartDate.isBefore(currentCreatedStart)) {
                    return {
                        ...prevState,
                        created_end: newStartDate.format("YYYY-MM-DD"),
                        created_start: newStartDate.clone().subtract(1, 'day').format("YYYY-MM-DD"),
                    };
                } else {
                    return {
                        ...prevState,
                        created_end: newStartDate.format("YYYY-MM-DD"),
                    };
                }
            }

            return {
                ...prevState,
                [name]: val
            }

        })
    }
    const query = qs.parse(location.search, {arrayFormat: 'comma'});

    const handleAdd = async () => {
        try {
            Object.entries(form).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    query[key] = value.map((item) => item.value);
                }else{
                    query[key] = value;

                }
            });
            window.open(`${REACT_APP_API_URL}download_dayoff_report/?${qs.stringify(query, {
                arrayFormat: 'comma',
                skipEmptyString: true,
            })}`, "_blank");


        } catch (e) {
            ErrorToast()
        }
    }
    useEffect(() => {
        (async () => {
            // await dispatch(accountantRequest())
            // await dispatch(taskManagerRequest())
        })();
    }, []);
    return (
        <Modal
            {...{onHide, show}}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered


        >
            <Modal.Header className='green-top'>
                <Modal.Title id="contained-modal-title-vcenter"
                             className="w-100 d-flex flex-row justify-content-between">
                    <span>{word.download}</span>
                    <div className="tool-tip-cont">
                        <div className="tool-tip">Փակել</div>
                        <i className="fas fa-times" onClick={onHide}/>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='container'>
                    <Row className="justify-content-center">
                        <Col xs={12} sm={10}>
                            <div className='input-validation'>
                                <TextField
                                    id="date"
                                    value={moment(form.start_date).format("YYYY-MM-DD")}
                                    label="Ժամանակացույց սկիզբ"
                                    type="date"
                                    onChange={(ev) => handleChange('start_date', ev.target.value)}
                                    variant="outlined"
                                    InputProps={{inputProps: {min: moment(new Date()).format("YYYY-MM-DD")}}}
                                    sx={{width: 250}}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </div>
                            <div className='input-validation'>
                                <TextField
                                    value={moment(form.end_date).format("YYYY-MM-DD")}
                                    id="date"
                                    label="Ժամանակացույց ավարտ"
                                    type="date"
                                    onChange={(ev) => handleChange('end_date', ev.target.value)}
                                    variant="outlined"
                                    InputProps={{inputProps: {min: moment(new Date()).format("YYYY-MM-DD")}}}
                                    sx={{width: 250}}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </div>
                            <div className='input-validation'>
                                <TextField
                                    id="date"
                                    value={moment(form.created_start).format("YYYY-MM-DD")}
                                    label="Ստեղծման սկիզբ"
                                    type="date"
                                    onChange={(ev) => handleChange('created_start', ev.target.value)}
                                    variant="outlined"
                                    InputProps={{inputProps: {min: moment(new Date()).format("YYYY-MM-DD")}}}
                                    sx={{width: 250}}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </div>
                            <div className='input-validation'>
                                <TextField
                                    value={moment(form.created_end).format("YYYY-MM-DD")}
                                    id="date"
                                    label="Ստեղծման ավարտ"
                                    type="date"
                                    onChange={(ev) => handleChange('created_end', ev.target.value)}
                                    variant="outlined"
                                    InputProps={{inputProps: {min: moment(new Date()).format("YYYY-MM-DD")}}}
                                    sx={{width: 250}}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </div>
                            <Select
                                value={form.creator_ids}
                                options={allOptions}
                                isMulti
                                onChange={option => handleChange('creator_ids', option)}
                            />
                            <div style={{marginTop: '20px'}} className='button-line'>
                                <BlueButton
                                    title={word.create}
                                    buttonStyle={"blue-button"}
                                    onChangeValue={() => handleAdd()}
                                />
                            </div>
                        </Col>
                    </Row>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default DayOffReport;